<template>
  <div class="speaker-search">
    <el-select v-model="value" filterable remote reserve-keyword clearable @clear="clearSelect" :placeholder="$t('event.textbox.search_')" @change="selectionChange" :remote-method="remoteMethod" :loading="loading">
      <el-option v-for="item in options" :key="item.id" :label="item.fullName" :value="item.id"> </el-option>
    </el-select>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SpeakerSearch",
  props: [],
  data() {
    return {
      options: [],
      value: [],
      loading: false
    };
  },
  mounted() {},
  methods: {
    clearSelect() {
      this.value = null;
      this.options = [];
      this.$emit("speakerSearchChanged", null);
    },
    async remoteMethod(query) {
      if (query !== "") {
        this.loading = true;

        var res = await axios.post("speaker/list", {
          searchTerm: query,
          skip: 0,
          take: 20
        });

        this.options = res.data.data.items;
        this.loading = false;
      } else {
        this.options = [];
      }
    },
    selectionChange(val) {
      this.$emit("speakerSearchChanged", val);
    },
    resetFilter() {
      this.value = null;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SpeakerSearch.vue